import React, { useEffect } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";

import PrivateRoute from './components/PrivateRoute/PrivateRoute';

import routes from "./routes";

import { useTranslation } from 'react-i18next';
import { ipapiService } from './services';

import "bootstrap/dist/css/bootstrap.min.css";
import "./shards-dashboard/styles/shards-dashboards.1.1.0.min.css";
import "./assets/global.css";

import { roleActions } from './actions';
import { useSelector, useDispatch } from 'react-redux';

export default () => {
  const { i18n } = useTranslation();
  const [dir, lang] = 'ltr/en-US';
  // i18n.changeLanguage(lang.split('-')[0]); // get first past of lang for Fa, En, Tr, Ar
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(roleActions.getAll());
  }, [])

  return (
    <Router basename={process.env.REACT_APP_BASENAME || ""}>
      <div>
        {routes.map((route, index) => {
          if (route.private) {
            return (
              <PrivateRoute
                key={index}
                path={route.path}
                exact={route.exact}
                component={route.component}
                layout={route.layout}
              />
            );
          } else {
            return (
              <Route
                key={index}
                path={route.path}
                exact={route.exact}
                component={route.component}
                layout={route.layout}
              />
            );
          }
        })}
      </div>
    </Router>
  )
};
